import React, { useEffect, useState } from 'react'
import { Col, Row, Space, Switch } from 'antd'
import { connect } from 'react-redux'
import { selectCurrentUser } from 'Store/user/selector'
import RootState from 'typings/RootState'
import { selectInquiryDeleteEvent } from 'Store/delivery-cost/selector'
import styled from 'styled-components'
import { DefaultStatus } from 'helpers/constanst'
import { StatusTag } from 'Components/utilities'
import { StockConfigData } from 'Store/stock/types'
import { cloneDeep } from 'lodash'
import ConfigForm from './ConfigForm'
import { MyTheme } from 'Components/common/Theme'

type Props = {
  data?: StockConfigData
  onUpdate: (data: StockConfigData) => void
} & ReduxProps

const AllProductConfig: React.FunctionComponent<Props> = props => {
  const { onUpdate, data } = props

  const initForm = {
    id: 0,
    is_all_product: 'yes',
    merchant_id: 0,
    products: [],
    min_qty: 0,
    status: DefaultStatus.INACTIVE,
  } as StockConfigData
  const [formData, setFormData] = useState(cloneDeep(initForm))
  const isActive = formData?.status === DefaultStatus.ACTIVE

  useEffect(() => {
    if (data) {
      setFormData(data)
    } else {
      setFormData(cloneDeep(initForm))
    }
  }, [data])

  const onUpdateData = (val: any, key: string) => {
    onUpdate({
      ...formData,
      [key]: val,
    })
  }

  const getTitle = (isActive: boolean) => (
    <TitleWrapper className="ttr-all">
      <Space align="start">
        <Switch
          checked={isActive}
          onChange={(val: boolean) =>
            onUpdateData(val ? DefaultStatus.ACTIVE : DefaultStatus.INACTIVE, 'status')
          }
        />
        <Title>แจ้งเตือนสต๊อกขั้นต่ำของสินค้าทั้งหมดในร้านค้า</Title>
        <StatusTag isPass={isActive === true} text={isActive ? 'เปิดใช้งาน' : 'ปิดใช้งาน'} />
      </Space>
    </TitleWrapper>
  )

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        {getTitle(isActive)}
        {isActive && <ConfigForm data={formData} onUpdate={onUpdate} />}
      </Col>
    </Row>
  )
}

const TitleWrapper = styled.div``
const Title = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  margin-bottom: 5px;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectInquiryDeleteEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(AllProductConfig)
